import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUserDataByCookies } from 'actions/AuthActions';

class EnsureLoggedIn extends Component {
  componentDidMount() {
    this.props.dispatch(fetchUserDataByCookies());
  }

  render() {
    return (
      <div className="App">
        {this.props.children}
      </div>
    );
  }
}

export default connect()(EnsureLoggedIn);



// WEBPACK FOOTER //
// ./src/containers/EnsureLoggedIn.js